export default Vue.extend({
  props: {
    title: {
      type: String,
      default: ''
    }
  },

  template: `
    <div class="namespaces-main-wrapper">
      <div class="namespaces-head" v-if="title || $slots.actions">
        <div class="namespaces-title">{{ title }}</div>
        <div class="namespaces-actions">
          <slot name="actions"></slot>
        </div>
      </div>

      <div class="namespaces-body">
        <slot name="content"></slot>
      </div>
    </div>
  `
})
